const exploreBtnTxt = [
    "Software Engineering",
    "Artificial Intelligence",
    "Cyber Security",
    "Data Engineering",
    // "DevOps",
    // "Web3 Technology",
]

export { exploreBtnTxt };